/**
 * Z-Index Hierarchy Constants
 * 
 * Use these constants across the app to maintain consistent layering.
 * Higher values appear on top of lower values.
 * 
 * HIERARCHY (from highest to lowest):
 * 1. NOTIFICATION (10000) - Toast notifications, always on top
 * 2. ACTIVE_CALL_BANNER (2200) - Incoming/active call banners
 * 3. AGENT_STATUS_BAR (1500) - Agent status indicator bar
 * 4. MODAL (1300) - All modals and dialogs (MUI default)
 * 5. FLOATING_BUTTON (1300) - Floating action buttons
 * 6. SIDEBAR (1200) - Navigation sidebar
 * 7. DEFAULT (1) - Regular page content
 */

export const Z_INDEX = {
  // Highest priority - always visible
  NOTIFICATION: 10000,
  
  // Call-related UI
  ACTIVE_CALL_BANNER: 2200,
  
  // Status bars
  AGENT_STATUS_BAR: 1500,
  
  // Overlays and modals
  MODAL: 1300,
  FLOATING_BUTTON: 1300,
  
  // Navigation
  SIDEBAR: 1200,
  
  // Base level
  DEFAULT: 1,
} as const;

export type ZIndexKey = keyof typeof Z_INDEX;

